import React, { useEffect, useSyncExternalStore } from 'react';
import { isInteractionLocked, subscribeInteractionLock } from '../utils/interactionLock';

/** Keys that would scroll the page */
const SCROLL_KEYS = new Set([' ', 'Spacebar', 'PageUp', 'PageDown', 'Home', 'End', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Tab']);

/**
 * While the site is locked (Pixel's full-charge short), a transparent shield swallows every
 * click and hover, and wheel / touch / keyboard scrolling is cancelled.
 */
export function InteractionShield() {
  const locked = useSyncExternalStore(subscribeInteractionLock, isInteractionLocked, isInteractionLocked);
  useEffect(() => {
    if (!locked) return;
    const stop = (e: Event) => {
      e.preventDefault();
      e.stopPropagation();
    };
    const onKey = (e: KeyboardEvent) => {
      if (SCROLL_KEYS.has(e.key)) stop(e);
    };
    const opts: AddEventListenerOptions = {
      passive: false,
      capture: true
    };
    window.addEventListener('wheel', stop, opts);
    window.addEventListener('touchmove', stop, opts);
    window.addEventListener('keydown', onKey, opts);
    // Keep the page exactly where it is, even if something slips through
    const y = window.scrollY;
    const pin = () => window.scrollTo(0, y);
    window.addEventListener('scroll', pin);
    return () => {
      window.removeEventListener('wheel', stop, opts);
      window.removeEventListener('touchmove', stop, opts);
      window.removeEventListener('keydown', onKey, opts);
      window.removeEventListener('scroll', pin);
    };
  }, [locked]);
  if (!locked) return null;
  return <div aria-hidden="true" className="fixed inset-0 z-[90] cursor-default touch-none" data-id="element-136" data-mp="35u7d6nxuz6a8" />;
}